import { useEffect, useState } from "react";

// ── useTenantBranding ──────────────────────────────────────────────────────
// Returns { name, logoUrl, primaryColor } for the candidate's tenant.
// Today: reads from localStorage if the auth flow stashed branding there
// (key: amplehire_tenant_branding, JSON-encoded).
// Future: replace the body of `read()` with a fetch to an endpoint like
// /api/candidate-portal/branding once it's wired.
//
// Fallback defaults are sane VF tokens so the layout always renders
// something coherent.

const STORAGE_KEY = "amplehire_tenant_branding";

const DEFAULTS = Object.freeze({
  name: "Ample Hire",
  logoUrl: null,
  primaryColor: "#7B5AC4", // matches the vf-primary token
});

function read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULTS;
    const parsed = JSON.parse(raw);
    return {
      name: parsed.name || DEFAULTS.name,
      logoUrl: parsed.logoUrl || null,
      primaryColor: parsed.primaryColor || DEFAULTS.primaryColor,
    };
  } catch {
    return DEFAULTS;
  }
}

export default function useTenantBranding() {
  const [branding, setBranding] = useState(read);

  useEffect(() => {
    // Re-read when other tabs (or our own auth flow) update the key.
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setBranding(read());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return branding;
}
